const DevEnvLogRocketStub = {
  captureMessage: (error: string, extraStuff: object): void => { console.error(`Error: ${error}`, extraStuff); },
  captureException: (error: string, extraStuff: object): void => { console.error(`Error: ${error}`, extraStuff); }
};

export default (window?.LogRocket || DevEnvLogRocketStub);

export const track = (userEvent: TrackedEvent): void => {
  window?.LogRocket?.track(userEvent); // eslint-disable-line no-unused-expressions
};

export enum TrackedEvent {
  AssetModalEditTabCreateAsset = 'asset_modal_edit_tab_create_asset',
  AssetModalEditTabModifyAsset = 'asset_modal_edit_tab_modify_asset',
  AssetModalEditTabSubmissionPartialSuccess = 'asset_modal_edit_tab_submission_partial_success',
  AssetModalEditTabUGTLocaleChange = 'asset_modal_edit_tab_ugt_locale_change',
  Boards = 'boards',
  CommentsAndAnnotations = 'comments_and_annotations',
  Cropping = 'cropping',
  SmartsheetPublish = 'smartsheet_publish',
  SmartsheetPublishNoResources = 'smartsheet_publish_no_resources',
  WebToPrint = 'web_to_print',
}
